import React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Typography from "@mui/material/Typography";
import { style } from "../../utils/styles";
import CrossButton from "../CrossButton";
import UpdateCommentForm from "../forms/UpdateCommentForm";

const EditCommentModal = ({ handleCommentText, comment, open, handleClose }) => {
    return (
        <Modal
            open={open}
            onClose={handleClose}
        >
            <Box bgcolor="background.default" sx={style}>
                <CrossButton handleClose={handleClose} />

                <Typography color="text.primary" sx={{ mb: "20px" }} variant='h5'>Update Text</Typography>

                <UpdateCommentForm handleClose={handleClose} comment={comment} handleCommentText={handleCommentText} />
            </Box>
        </Modal>
    )
}

export default EditCommentModal;